(function () {
  "use strict";

  var MAX_FILE_SIZE = 5 * 1024 * 1024;
  var ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

  var copy = {
    ar: {
      required: "هذا الحقل مطلوب.",
      email: "أدخل بريدًا إلكترونيًا صحيحًا.",
      phone: "أدخل رقم هاتف صحيح.",
      serial: "أدخل باركود صحيح مكوّن من 12 إلى 14 رقمًا.",
      barcodeMismatch: "الباركود لا يطابق المنتج المحدد.",
      date: "أدخل تاريخ شراء صحيح لا يكون في المستقبل.",
      bot: "تعذر إرسال الطلب. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      fileType: "يمكن رفع PDF أو صورة JPG/PNG/WebP فقط.",
      fileSize: "حجم الملف يجب ألا يتجاوز 5MB.",
      missingConfig: "إعدادات Supabase غير مكتملة. أضف anon public key من إعدادات القسم.",
      loading: "جاري التفعيل...",
      submit: "تفعيل الضمان",
      duplicate: "هذا الرقم التسلسلي مسجل بالفعل.",
      storageError: "تعذر رفع الفاتورة. جرّب الإرسال بدون فاتورة أو تحقق من إعدادات Storage في Supabase.",
      tableError: "تعذر حفظ البيانات. تحقق من تشغيل ملف SQL في Supabase ومن إعدادات RLS.",
      missingTable: "جدول warranty_registrations غير موجود. شغّل ملف SQL في Supabase أولًا.",
      success: "تم تفعيل الضمان بنجاح.",
      generic: "حدث خطأ أثناء الإرسال. حاول مرة أخرى."
    },
    en: {
      required: "This field is required.",
      email: "Enter a valid email address.",
      phone: "Enter a valid phone number.",
      serial: "Enter a valid 12 to 14 digit barcode.",
      barcodeMismatch: "The barcode does not match the selected product.",
      date: "Enter a valid purchase date that is not in the future.",
      bot: "The request could not be submitted. Please refresh the page and try again.",
      fileType: "Only PDF or JPG/PNG/WebP images are allowed.",
      fileSize: "File size must be 5MB or less.",
      missingConfig: "Supabase settings are incomplete. Add the anon public key in section settings.",
      loading: "Activating...",
      submit: "Activate warranty",
      duplicate: "This serial number is already registered.",
      storageError: "Invoice upload failed. Try submitting without an invoice or check Supabase Storage settings.",
      tableError: "Could not save the registration. Check that the SQL setup was run and RLS is configured.",
      missingTable: "The warranty_registrations table does not exist. Run the Supabase SQL setup first.",
      success: "Warranty activated successfully.",
      generic: "Something went wrong. Please try again."
    }
  };

  function getMessages(language) {
    return copy[language] || copy.ar;
  }

  function normalizeDigits(value) {
    var arabic = "٠١٢٣٤٥٦٧٨٩";
    var persian = "۰۱۲۳۴۵۶۷۸۹";

    return String(value || "").replace(/[٠-٩۰-۹]/g, function (digit) {
      var arabicIndex = arabic.indexOf(digit);
      if (arabicIndex > -1) return String(arabicIndex);
      return String(persian.indexOf(digit));
    });
  }

  function safeFileName(name) {
    return String(name || "invoice")
      .toLowerCase()
      .replace(/[^a-z0-9.\-_]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function extensionForFile(file) {
    var extensions = {
      "image/jpeg": "jpg",
      "image/png": "png",
      "image/webp": "webp",
      "application/pdf": "pdf"
    };

    return extensions[file.type] || safeFileName(file.name).split(".").pop() || "file";
  }

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === "x" ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }

  function setError(root, fieldName, message) {
    var field = root.querySelector('[name="' + fieldName + '"]');
    var error = root.querySelector('[data-error-for="' + fieldName + '"]');

    if (field) {
      field.setAttribute("aria-invalid", message ? "true" : "false");
    }

    if (error) {
      error.textContent = message || "";
    }
  }

  function showToast(root, message, type) {
    var toast = root.querySelector("[data-toast]");
    if (!toast) return;

    toast.textContent = message;
    toast.className = "wa-toast" + (type ? " is-" + type : "");
    toast.hidden = false;

    window.clearTimeout(toast._waTimer);
    toast._waTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, 4200);
  }

  function setFormAlert(root, message) {
    var alert = root.querySelector("[data-form-error]");
    if (!alert) return;

    alert.textContent = message || "";
    alert.hidden = !message;
  }

  function setLoading(form, isLoading, messages) {
    var button = form.querySelector("[data-submit-button]");
    var text = form.querySelector("[data-submit-text]");

    if (!button || !text) return;

    button.disabled = isLoading;
    button.classList.toggle("is-loading", isLoading);
    text.textContent = isLoading ? messages.loading : messages.submit;
  }

  function applyLanguage(root, language) {
    root.dataset.language = language;
    root.setAttribute("lang", language);
    root.setAttribute("dir", language === "ar" ? "rtl" : "ltr");

    var languageInput = root.querySelector('[name="language"]');
    if (languageInput) languageInput.value = language;

    root.querySelectorAll("[data-i18n-ar][data-i18n-en]").forEach(function (element) {
      if (element.hasAttribute("data-file-name")) {
        var invoiceInput = root.querySelector('[name="invoice"]');
        if (invoiceInput && invoiceInput.files && invoiceInput.files[0]) return;
      }

      var value = element.getAttribute("data-i18n-" + language);
      if (value !== null) element.textContent = value;
    });

    root.querySelectorAll("[data-aria-label-ar][data-aria-label-en]").forEach(function (element) {
      var value = element.getAttribute("data-aria-label-" + language);
      if (value !== null) element.setAttribute("aria-label", value);
    });

    root.querySelectorAll("[data-language-switch]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-language-switch") === language ? "true" : "false");
    });
  }

  function validate(form, root, messages) {
    var formData = new FormData(form);
    var errors = {};
    var requiredFields = ["full_name", "phone", "email", "product", "retailer", "serial_number", "purchase_date"];
    var loadedAt = Number(formData.get("form_loaded_at") || 0);
    var elapsed = loadedAt ? Date.now() - loadedAt : 0;

    if (String(formData.get("company_website") || "").trim() || elapsed < 2500) {
      errors.form = messages.bot;
    }

    requiredFields.forEach(function (fieldName) {
      if (!String(formData.get(fieldName) || "").trim()) {
        errors[fieldName] = messages.required;
      }
    });

    var email = String(formData.get("email") || "").trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = messages.email;
    }

    if (email && email.length > 160) {
      errors.email = messages.email;
    }

    var phone = normalizeDigits(formData.get("phone")).replace(/[^\d+]/g, "");
    var phoneDigits = phone.replace(/\D/g, "");
    if (phone && (phoneDigits.length < 8 || phoneDigits.length > 15)) {
      errors.phone = messages.phone;
    }

    var serial = normalizeDigits(formData.get("serial_number")).replace(/\D/g, "");
    if (serial && !/^\d{12,14}$/.test(serial)) {
      errors.serial_number = messages.serial;
    }

    var purchaseDate = String(formData.get("purchase_date") || "");
    if (purchaseDate) {
      var selected = new Date(purchaseDate + "T00:00:00");
      var today = new Date();
      today.setHours(23, 59, 59, 999);
      if (Number.isNaN(selected.getTime()) || selected > today) {
        errors.purchase_date = messages.date;
      }
    }

    var invoice = form.querySelector('[name="invoice"]');
    var file = invoice && invoice.files ? invoice.files[0] : null;
    if (file) {
      if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1) {
        errors.invoice = messages.fileType;
      } else if (file.size > MAX_FILE_SIZE) {
        errors.invoice = messages.fileSize;
      }
    }

    ["full_name", "phone", "email", "product", "retailer", "serial_number", "purchase_date", "invoice"].forEach(function (fieldName) {
      setError(root, fieldName, errors[fieldName]);
    });

    return {
      isValid: Object.keys(errors).length === 0,
      formError: errors.form,
      serial: serial,
      phone: phone,
      file: file
    };
  }

  async function uploadInvoice(client, bucket, file, serial) {
    if (!file) return "";

    var extension = extensionForFile(file);
    var path = [
      "warranty",
      serial,
      Date.now() + "-" + Math.random().toString(36).slice(2) + "." + extension
    ].join("/");

    var result = await client.storage.from(bucket).upload(path, file, {
      cacheControl: "3600",
      contentType: file.type,
      upsert: false
    });

    if (result.error) {
      result.error._waStage = "storage";
      throw result.error;
    }

    return path;
  }

  function isDuplicateError(error) {
    if (!error) return false;
    return error.code === "23505" || /duplicate|unique|serial/i.test(error.message || "");
  }

  function getFriendlyError(error, messages) {
    if (isDuplicateError(error)) return messages.duplicate;
    if (error && error._waStage === "storage") return messages.storageError;
    if (error && (error.code === "42P01" || /relation .* does not exist|does not exist/i.test(error.message || ""))) {
      return messages.missingTable;
    }
    if (error && (error.code === "42501" || /row-level security|violates row-level security|permission denied/i.test(error.message || ""))) {
      return messages.tableError;
    }
    return messages.generic;
  }

  function initWarranty(root) {
    var form = root.querySelector("[data-warranty-form]");
    if (!form || form.dataset.initialized === "true") return;

    form.dataset.initialized = "true";

    var language = root.dataset.language || root.getAttribute("lang") || "ar";
    var messages = getMessages(language);
    var supabaseUrl = root.dataset.supabaseUrl;
    var supabaseKey = root.dataset.supabaseKey;
    var bucket = root.dataset.storageBucket || "warranty-invoices";
    var successPanel = root.querySelector("[data-success-panel]");
    var fileInput = form.querySelector('[name="invoice"]');
    var fileName = root.querySelector("[data-file-name]");
    var resetButton = root.querySelector("[data-reset-form]");
    var loadedAtInput = form.querySelector("[data-form-loaded-at]");

    if (loadedAtInput) loadedAtInput.value = String(Date.now());

    if (fileInput && fileName) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        fileName.textContent = file ? file.name : fileName.textContent;
      });
    }

    root.querySelectorAll("[data-language-switch]").forEach(function (button) {
      button.addEventListener("click", function () {
        language = button.getAttribute("data-language-switch") || "ar";
        messages = getMessages(language);
        applyLanguage(root, language);
        setFormAlert(root, "");
        root.querySelectorAll(".wa-error").forEach(function (error) {
          error.textContent = "";
        });
      });
    });

    applyLanguage(root, language);

    form.querySelectorAll("input, select").forEach(function (field) {
      field.addEventListener("input", function () {
        setError(root, field.name, "");
        setFormAlert(root, "");
      });
      field.addEventListener("change", function () {
        setError(root, field.name, "");
        setFormAlert(root, "");
      });
    });

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      setFormAlert(root, "");

      var validation = validate(form, root, messages);
      if (!validation.isValid) {
        if (validation.formError) setFormAlert(root, validation.formError);
        showToast(root, messages.generic, "error");
        return;
      }

      if (!window.supabase || !supabaseUrl || !supabaseKey) {
        setFormAlert(root, messages.missingConfig);
        showToast(root, messages.missingConfig, "error");
        return;
      }

      var client = window.supabase.createClient(supabaseUrl, supabaseKey, {
        auth: { persistSession: false }
      });

      setLoading(form, true, messages);

      try {
        var formData = new FormData(form);
        var registrationId = createId();
        var invoicePath = await uploadInvoice(client, bucket, validation.file, validation.serial);

        var payload = {
          id: registrationId,
          full_name: String(formData.get("full_name") || "").trim(),
          phone: validation.phone,
          email: String(formData.get("email") || "").trim().toLowerCase(),
          product: String(formData.get("product") || "").trim(),
          retailer: String(formData.get("retailer") || "").trim(),
          serial_number: validation.serial,
          purchase_date: String(formData.get("purchase_date") || "").trim(),
          invoice_url: invoicePath,
          language: String(formData.get("language") || language || "ar").trim(),
          status: "active"
        };

        var insertResult = await client
          .from("warranty_registrations")
          .insert(payload);

        if (insertResult.error) {
          insertResult.error._waStage = "database";
          throw insertResult.error;
        }

        form.hidden = true;
        if (successPanel) successPanel.hidden = false;
        showToast(root, messages.success, "success");
      } catch (error) {
        window.console && console.error && console.error("Warranty activation error:", error);
        var message = getFriendlyError(error, messages);
        if (error && error.code === "23514") message = messages.barcodeMismatch;
        if (isDuplicateError(error)) setError(root, "serial_number", message);
        if (error && error.code === "23514") setError(root, "serial_number", message);
        setFormAlert(root, message);
        showToast(root, message, "error");
      } finally {
        setLoading(form, false, messages);
      }
    });

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        form.reset();
        form.hidden = false;
        if (successPanel) successPanel.hidden = true;
        setFormAlert(root, "");
        form.querySelectorAll("[aria-invalid]").forEach(function (field) {
          field.setAttribute("aria-invalid", "false");
        });
        root.querySelectorAll(".wa-error").forEach(function (error) {
          error.textContent = "";
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-warranty-root]").forEach(initWarranty);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector("[data-warranty-root]");
    if (root) initWarranty(root);
  });
})();
